const INITIAL_STATE = {
    slides: [],
    slide: {},
    count: 0,
    loading: false
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case "GET_SLIDES": {
        return {
          ...state,
          slides: action.data,
          count: action.count,
          loading: false
        }
      }
      case "GET_SLIDE": {
        return {
          ...state,
          slide: action.data,
          loading: false
        }
      }
      default:
        return state
    }
  }
  